import { render } from "./PostSection.vue?vue&type=template&id=a01a842e"
import script from "./PostSection.vue?vue&type=script&lang=js"
export * from "./PostSection.vue?vue&type=script&lang=js"

import "./PostSection.vue?vue&type=style&index=0&id=a01a842e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__